import * as React from 'react';

export default () => (
  <svg width="24" height="24" fill="none">
    <path
      stroke="#B5BFD2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m5 16 6.212 2.662a2 2 0 0 0 1.576 0L19 16M5 12l6.606 2.831a1 1 0 0 0 .788 0L19 12"
    />
    <path
      fill="#E2E5ED"
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M12.788 5.338 19 8l-6.212 2.662a2 2 0 0 1-1.576 0L5 8l6.212-2.662a2 2 0 0 1 1.576 0Z"
    />
    <path
      fill="#E2E5ED"
      d="M12.394 5.169 19 8l-6.606 2.831a1 1 0 0 1-.788 0L5 8l6.606-2.831a1 1 0 0 1 .788 0Z"
    />
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.394 5.169 19 8l-6.606 2.831a1 1 0 0 1-.788 0L5 8l6.606-2.831a1 1 0 0 1 .788 0Z"
    />
    <path
      stroke="#B5BFD2"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.394 5.169 19 8l-6.606 2.831a1 1 0 0 1-.788 0L5 8l6.606-2.831a1 1 0 0 1 .788 0Z"
    />
  </svg>
);
